import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegions, setRegions } from "../../slices/app";
export const useRegions = () => {
    const dispatch = useDispatch();
    const value = useSelector(getRegions);
    const update = useCallback((updatedValue) => {
        dispatch(setRegions(updatedValue));
    }, [dispatch]);
    return [value, update];
};
